import React from 'react';
import { FadeIn } from './FadeIn';
import { Sun } from 'lucide-react';
export function Proof() {
  return <section className="bg-lavender py-24 px-6 md:px-12 relative overflow-hidden" data-id="element-132">
      <div className="max-w-4xl mx-auto text-center" data-id="element-133">
        <FadeIn data-id="element-134">
          <div className="flex justify-center mb-6" data-id="element-135">
            <Sun className="w-10 h-10 text-amber" data-id="element-136" />
          </div>
          <h2 className="text-4xl md:text-5xl mb-12" data-id="element-137">
            Lo que cambia en 7 días
          </h2>
        </FadeIn>

        <div className="space-y-8 text-xl md:text-2xl font-medium text-brown/80" data-id="element-138">
          <FadeIn delay={0.1} data-id="element-139">
            <p className="bg-white/60 p-6 rounded-2xl shadow-sm" data-id="element-140">
              Vos te despertás sintiéndote otra persona. La niebla mental se va,
              volvés a tener paciencia y empezás a disfrutar del día en vez de
              solo sobrevivirlo.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-141">
            <p className="bg-white/60 p-6 rounded-2xl shadow-sm" data-id="element-142">
              Tu bebé duerme tramos más largos, se despierta de mejor humor y
              está más tranquilo durante el día. Notás que algo cambió en su
              descanso.
            </p>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-143">
            <p className="bg-white/60 p-6 rounded-2xl shadow-sm" data-id="element-144">
              Las noches dejan de ser una batalla. Hay más calma en casa, más
              conexión con tu pareja y más energía para todo lo que importa.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}